var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetAllMenuQuery } from "@/store/api";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import queryString from "query-string";
import { faChevronDown, faChevronRight, } from "@fortawesome/pro-solid-svg-icons";
import { useMemo, useState } from "react";
export default function Placeholder() {
    var _a;
    var menuResponse = useGetAllMenuQuery(null).data;
    // Memo : all modules used for translation
    var allModules = useMemo(function () {
        var _a, _b, _c, _d;
        var value = ((_d = (_c = (_b = (_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.tabs) === null || _c === void 0 ? void 0 : _c.LBL_TABGROUP_ALL) === null || _d === void 0 ? void 0 : _d.modules) || {};
        return Object.keys(value);
    }, [menuResponse]);
    var t = useTranslation("common").t;
    var _b = useState(null), openedMenu = _b[0], setOpenedMenu = _b[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var main = ((_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) || [];
    var createMenu = useMemo(function () {
        var _a, _b, _c, _d;
        var list = main || {};
        var links = (list === null || list === void 0 ? void 0 : list.links) || {};
        var moduleLinks = {};
        var modules = (_b = (_a = list === null || list === void 0 ? void 0 : list.tabs) === null || _a === void 0 ? void 0 : _a.LBL_TABGROUP_ALL) === null || _b === void 0 ? void 0 : _b.modules;
        var _loop_1 = function (moduleKey) {
            var clientLinks = {};
            var linksUrls = (_c = links[moduleKey]) === null || _c === void 0 ? void 0 : _c.links;
            var image = (_d = links[moduleKey]) === null || _d === void 0 ? void 0 : _d.image;
            linksUrls.forEach(function (element) {
                var window = {};
                var location = window.location || {};
                var protocol = location.protocol || "http";
                var host = location.host || "localhost";
                var url = new URL(element.url, process.env.ETCRM_URL || "".concat(protocol, "://").concat(host));
                var query = url.search.split("?");
                var qs = query.length > 1 ? query[1] : query[0];
                var queryParts = queryString.parse(qs);
                var newLinkParts = [];
                var module = queryParts.module || "";
                var action = queryParts.action && queryParts.action !== "index"
                    ? queryParts.action
                    : "";
                delete queryParts.module;
                delete queryParts.action;
                for (var p in queryParts) {
                    newLinkParts.push("".concat(p, "=").concat(queryParts[p]));
                }
                var q = newLinkParts.length > 0 ? "?".concat(newLinkParts.join("&")) : "";
                clientLinks[element.id] = "".concat(module, "/").concat(action).concat(q);
            });
            moduleLinks[moduleKey] = {
                links: links[moduleKey],
                clientLinks: clientLinks,
                image: image,
            };
        };
        for (var moduleKey in modules) {
            _loop_1(moduleKey);
        }
        return moduleLinks;
    }, [main]);
    var filteredMenu = function () {
        var links = [];
        var menu = createMenu;
        for (var m in menu) {
            if (menu[m].links.links.length) {
                links[m] = menu[m];
            }
        }
        return links;
    };
    // show or not children's menu
    var toggleMenu = function (item) {
        if (openedMenu === item) {
            setOpenedMenu(null);
        }
        else {
            setOpenedMenu(item);
        }
    };
    var menuAll = Object.values(filteredMenu());
    return (_jsx("div", __assign({ className: "h-full px-3 py-4 overflow-auto bg-[var(--colors-menu-east-bg)]" }, { children: _jsx("div", __assign({ className: "space-y-2 text-[var(--colors-label)]" }, { children: menuAll === null || menuAll === void 0 ? void 0 : menuAll.map(function (item, key) {
                var _a, _b, _c, _d;
                return (_jsxs("div", __assign({ className: "menu-contain ".concat(openedMenu === ((_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.label) ? "open" : "") }, { children: [_jsxs("p", __assign({ className: "menu-contain__label flex uppercase cursor-pointer text-justify p-1 relative ".concat(openedMenu === ((_b = item === null || item === void 0 ? void 0 : item.links) === null || _b === void 0 ? void 0 : _b.label) ? "bg-[#5485e6]" : "") }, { children: [_jsx("span", __assign({ className: "pr-4" }, { children: t(item === null || item === void 0 ? void 0 : item.links.label) })), _jsx(FontAwesomeIcon, { icon: openedMenu === (item === null || item === void 0 ? void 0 : item.links.label)
                                        ? faChevronDown
                                        : faChevronRight, onClick: function () { var _a; return toggleMenu((_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.label); }, className: "absolute right-0 top-2 mr-4" })] })), _jsx("ul", __assign({ className: openedMenu === ((_c = item === null || item === void 0 ? void 0 : item.links) === null || _c === void 0 ? void 0 : _c.label)
                                ? "menu-contain__list block"
                                : "menu-contain__list hidden" }, { children: (_d = item === null || item === void 0 ? void 0 : item.links) === null || _d === void 0 ? void 0 : _d.links.map(function (i, key) {
                                var _a, _b, _c;
                                return (_jsx("li", __assign({ className: "hover:bg-[#5485e6] px-2 py-1" }, { children: _jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(item.clientLinks[i.id]), title: i.label }, { children: _jsx("span", { children: ((_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.mod_strings) !== null &&
                                                ((_b = item === null || item === void 0 ? void 0 : item.links) === null || _b === void 0 ? void 0 : _b.mod_strings[i.label])
                                                ? (_c = item === null || item === void 0 ? void 0 : item.links) === null || _c === void 0 ? void 0 : _c.mod_strings[i.label]
                                                : i.label }) })) }), key));
                            }) }))] }), key));
            }) })) })));
}
